import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Id, TaskRetrievalResponse } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedTask: boolean;
  task: TaskRetrievalResponse;
  retrieveTask(request: Boundaries["retrieveTask"]["request"]): void;
}

function useTaskRetrieval(taskId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isTaskRetrievalRequestPending(taskId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isTaskRetrievalRequestSuccess(taskId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isTaskRetrievalRequestFailure(taskId),
    ),
    hasRetrievedTask: useSelector(() => selector.hasRetrievedTask(taskId)),
    task: useSelector(() => selector.getTask(taskId)),
    retrieveTask: core.retrieveTask,
  };
}

export { useTaskRetrieval };
